export const ROOT = '/';
export const GAME = '/game';
export const HOME = '/';
export const HOW_TO_EARN = '/how-to-earn';
export const HOW_TO_PLAY = '/how-to-play';
export const FAQS = '/faqs';
export const TERMS_OF_SERVICE = '/terms-of-service';
export const PRIVACY_POLICY = '/privacy-policy';
export const FOLLOW_US = '/follow-us';
export const PLAY_AND_EARN = '/play-and-earn';
export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const FORGOT_PASSWORD = '/forgot-password';
export const FORGOT_PASSWORD_SUCCESS = '/forgot-password-success';
export const OTP_VERIFY = '/otp-verify';
export const CONVERT = '/exchange/convert';
export const SELL_EARN = '/exchange/sell-earn';
export const PURCHASE = '/exchange/purchase';
export const CRAFT = '/craft-tools';
export const MYTOOLS = '/mytools';
